import Localization from 'lib/localization';

export default {
    lxTitle() {
        return Localization.get('badoo_homepage@create_password.page.title');
    },

    lxBody() {
        return Localization.get('badoo_homepage@create_password.page.body');
    },

    lxPasswordFieldLabel() {
        return Localization.get('badoo_homepage@create_password.page.password.field.label');
    },

    lxConfirmFieldLabel() {
        return Localization.get('badoo_homepage@create_password.page.confirm.field.label');
    },

    lxPasswordFieldHint() {
        return Localization.get('badoo_homepage@create_password.page.password.field.hint');
    },

    lxButtonSubmit() {
        return Localization.get('badoo_homepage@create_password.page.button_submit');
    },
};
